import { render, staticRenderFns } from "./MBTIPage.vue?vue&type=template&id=4ed3cab9&"
import script from "./MBTIPage.vue?vue&type=script&lang=js&"
export * from "./MBTIPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports